import React from 'react';

import TopNav from './TopNav';

export default function Navbar() {
  return (
    <>
      <TopNav />
    </>
  );
}
